module.exports = __webpack_public_path__ + "static/img/tab-one-active.6c286a72.png";